import {FilterRule} from '@/classes/FilterRule';

export default {
    namespaced: true,

    state: {
        totalValueThreshold: 0,
        reportFilters: [
            new FilterRule("totalVal",">", 0),
        ],
    },

    mutations: {
        changeTotalValueThreshold(state, value) {
            state.totalValueThreshold = value;
        },

        addFilter(state, payload) {
            let indexOfFilter =
                state.reportFilters.findIndex(item =>
                    item.attribute === payload.attribute &&
                    (item.operator !== "==" && item.operator === payload.operator)
                );

            if (indexOfFilter !== -1) {
                state.reportFilters[indexOfFilter] = payload;
            } else {
                state.reportFilters.push(payload);
            }
        },

        removeFilter(state, payload) {
            let indexOfFilter =
                state.reportFilters.findIndex(item =>
                    item.attribute === payload.attribute
                    &&
                    item.operator === payload.operator
                    &&
                    item.value === payload.value
                );
            if (indexOfFilter !== -1) {
                state.reportFilters.splice(indexOfFilter, 1);
            }
        },

        clearFilters(state) {
            state.reportFilters = [];
        }
    },

    actions: {
        setTotalValueThreshold ({ commit }, value) {
            commit('changeTotalValueThreshold', value);
            return value;
        },

        addNewFilter ({ commit }, payload) {
            commit('addFilter', payload);
            return payload;
        },

        removeExistingFilter ({ commit }, payload) {
            commit('removeFilter', payload);
            return payload;
        },

        clearAllFilters ({ commit }) {
            commit('clearFilters');
            return true;
        }
    },

    getters: {
        getTotalValueThreshold: state => state.totalValueThreshold,
        getFilters: state => state.reportFilters,
    }
}